import { render, staticRenderFns } from "./end_screen.html?vue&type=template&id=4610632a&scoped=true&"
import script from "./end_screen.js?vue&type=script&lang=js&"
export * from "./end_screen.js?vue&type=script&lang=js&"
import style0 from "./end_screen.css?vue&type=style&index=0&id=4610632a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610632a",
  null
  
)

export default component.exports